import { TableCell, TableRow } from "@mui/material";
import moment from "moment";

import { TDateISO } from "api/common/types/datetime.types";
import { ProgressPoint } from "api/memberPortal/project/progressPoints/progressPoints.types";

const FORMAT_DATE = (date: TDateISO | undefined) => {
  if (!date) return "-";
  return moment.utc(date).format("MM/DD/YYYY");
};

interface RowData {
  key: string;
  point: ProgressPoint;
  suffix: string;
  estDate: TDateISO | undefined;
  subDate: TDateISO | undefined;
}

const ProgressPointRow = ({ rowData }: { rowData: RowData }) => {
  const { point, suffix, estDate, subDate } = rowData;

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell component="th" scope="row" sx={{ padding: "4px 8px" }}>
        PP{point.progress_point}
        {suffix}
      </TableCell>
      <TableCell sx={{ padding: "4px 8px" }}>{FORMAT_DATE(estDate)}</TableCell>
      <TableCell sx={{ padding: "4px 8px" }}>{FORMAT_DATE(subDate)}</TableCell>
    </TableRow>
  );
};

export default ProgressPointRow;
